module.exports = __webpack_public_path__ + "img/Industrial.b37c9dff.jpg";